import React from 'react';

import { Colors } from 'constants/Clementine';

export const ProductContext = React.createContext({
  color: Colors.BLUE.hex
});
